import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { useMediaQuery } from '~/hooks';

export const TableHeader = () => {
  const [isSmallScreen] = useMediaQuery(['lg']);

  return (
    <thead style={{ borderBottom: `2px solid ${colors.neutral[150]}` }}>
      <tr>
        <th style={{ width: 76 }} />
        <th style={{ textAlign: 'left' }}>
          <Typography bold color={colors.primary[500]}>
            Professional
          </Typography>
        </th>
        {!isSmallScreen && (
          <th style={{ textAlign: 'left' }}>
            <Typography bold color={colors.primary[500]}>
              Office
            </Typography>
          </th>
        )}
        <th style={{ textAlign: 'left' }}>
          <Typography bold color={colors.primary[500]}>
            Details
          </Typography>
        </th>
        <th style={{ textAlign: 'left' }}>
          <Typography bold color={colors.primary[500]}>
            Review Hours
          </Typography>
        </th>
        <th />
      </tr>
    </thead>
  );
};
